import styled from 'styled-components';

const InputCheckBox = styled.div`
  label {
    display: flex;
    align-items: center;
    cursor: pointer;

    input[type="checkbox"] {
      width: 18px;
      height: 18px;
      margin-right: 8px;
      cursor: pointer;
    }

    span {
      font-size: 14px;
    }
  }
`;

type Props = {
  label: string;
  checked: boolean;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
};
export const CheckBox = (props: Props) => {
  return (
    <InputCheckBox>
      <label>
        <input
          type="checkbox"
          checked={props.checked}
          disabled={props.disabled}
          onChange={() => {
            props.onChange(!props.checked);
          }}
        />
        <span style={{ color: '#2A2C2F' }}>{props.label}</span>
      </label>
    </InputCheckBox>
  );
};
